import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'
import { StepApprovalType } from 'src/interfaces/onboardingTemplate'
import { InsurancePoliciesTableFields, InsurancePolicyProductsTableFields } from './enums'

export const insurancePolicyTableHeaderTitles: Record<InsurancePoliciesTableFields, string> = {
  [InsurancePoliciesTableFields.name]: 'Name',
  [InsurancePoliciesTableFields.permanentId]: 'Permanent ID',
  [InsurancePoliciesTableFields.products]: 'Products in policy',
  [InsurancePoliciesTableFields.createdAt]: 'Date created',
  // The actions column is buttons only; a header would just add noise.
  [InsurancePoliciesTableFields.actions]: '',
}

export const insurancePolicyProductTableHeaderTitles: Record<
  InsurancePolicyProductsTableFields,
  string
> = {
  [InsurancePolicyProductsTableFields.product]: 'Product',
  [InsurancePolicyProductsTableFields.allowOptOut]: 'Opt-out',
  [InsurancePolicyProductsTableFields.feeCents]: 'Fee',
  [InsurancePolicyProductsTableFields.feePercent]: 'Fee %',
  [InsurancePolicyProductsTableFields.feeCapCents]: 'Max fee',
  [InsurancePolicyProductsTableFields.feeFrequency]: 'Frequency',
  [InsurancePolicyProductsTableFields.contract]: 'Contract',
  [InsurancePolicyProductsTableFields.description]: 'Description',
  [InsurancePolicyProductsTableFields.actions]: '',
}

// A customer holds a handful of policies, and a policy a handful of products, so both tables
// stop at 100. The customers list carries 500/1000 only because of an explicit product request
// recorded alongside it.
export const insurancePolicyPageSizeOptions = [25, 50, 100]

export const INSURANCE_POLICIES_GRID_COLUMNS_STORAGE_KEY = 'admin.insurancePolicies.gridColumns'

// Product chips shown inline before collapsing the remainder into "+N", matching the onboarding
// templates table's "What it collects" column. Two rather than that column's three: these names
// ("Insurance Product 1") are longer than a step label, and this column is 40px narrower.
export const MAX_VISIBLE_PRODUCT_CHIPS = 2
export const INSURANCE_POLICY_PRODUCTS_GRID_COLUMNS_STORAGE_KEY =
  'admin.insurancePolicyProducts.gridColumns'

/**
 * All FIVE members of para-node's `CollectDataApprovalType`. Notion and the approved prototype
 * both list only four — they omit `customer_then_internal_approval`. Follow the backend.
 *
 * Defined here rather than imported: two copies already exist
 * (`components/flow-editor/stepConfigForms/shared/constants.ts` and
 * `pages/admin/flow-editor/constants.ts`), and importing a page-scoped constant into a shared
 * component would be worse than a third copy. Consolidating the existing two is an unrelated
 * refactor. Labels match the `stepConfigForms/shared` copy.
 */
export const INSURANCE_APPROVAL_TYPE_OPTIONS: BasicSelectOption[] = [
  { label: 'Auto Approval', value: StepApprovalType.AutoApproval },
  { label: 'Customer Approval', value: StepApprovalType.CustomerApproval },
  { label: 'Internal Approval', value: StepApprovalType.InternalApproval },
  { label: 'Internal then Customer', value: StepApprovalType.InternalThenCustomerApproval },
  { label: 'Customer then Internal', value: StepApprovalType.CustomerThenInternalApproval },
]
